import React, { useEffect } from "react";

const PostHogInitializer = () => {
  useEffect(() => {
    // Load the PostHog script dynamically
    (function (t, e) {
      if (!e.__SV) {
        const windowPostHog = (window.posthog = e);
        windowPostHog._i = [];
        windowPostHog.init = function (i, s, a) {
          function g(t, e) {
            const o = e.split(".");
            if (o.length === 2) {
              t = t[o[0]];
              e = o[1];
            }
            t[e] = function () {
              t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            };
          }
          const p = t.createElement("script");
          p.type = "text/javascript";
          p.crossOrigin = "anonymous";
          p.async = true;
          p.src =
            s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") +
            "/static/array.js";
          p.id = "posthog-script"; // Add an ID for easy removal

          const r = t.getElementsByTagName("script")[0];
          r.parentNode.insertBefore(p, r);

          let u = e;
          if (a !== undefined) {
            u = e[a] = [];
          } else {
            a = "posthog";
          }
          u.people = u.people || [];
          u.toString = function (t) {
            let e = "posthog";
            if (a !== "posthog") {
              e += "." + a;
            }
            if (!t) {
              e += " (stub)";
            }
            return e;
          };
          u.people.toString = function () {
            return u.toString(1) + ".people (stub)";
          };
          const methods =
            "init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(
              " "
            );
          for (let n = 0; n < methods.length; n++) {
            g(u, methods[n]);
          }
          e._i.push([i, s, a]);
        };
        e.__SV = 1;
      }
    })(document, window.posthog || {});

    // Initialize PostHog
    window.posthog.init("phc_QW3C8GBNtOlL6whmCwxHSnxlEn0I7p9WsUmKRDN2Odj", {
      api_host: "https://us.i.posthog.com",
      person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
    });

    return () => {
      // Cleanup: Remove the script from the DOM when component unmounts
      const script = document.getElementById("posthog-script");
      if (script) {
        script.remove();
      }

      // Cleanup PostHog instance
      if (window.posthog) {
        window.posthog.reset();
        delete window.posthog;
      }
    };
  }, []);

  return null; // This component doesn't render any UI
};

export default PostHogInitializer;
